'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _CartItem = require('./../components/CartItem');

var _CartItem2 = _interopRequireDefault(_CartItem);

var _GiftItemMini = require('./../components/GiftItemMini');

var _GiftItemMini2 = _interopRequireDefault(_GiftItemMini);

var _urls = require('../../urls');

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var Cart = function (_Component) {
    (0, _inherits3.default)(Cart, _Component);

    function Cart() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Cart);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Cart.__proto__ || (0, _getPrototypeOf2.default)(Cart)).call.apply(_ref, [this].concat(args))), _this), _this.closeMiniCart = function (e) {
            e.preventDefault();
            $('#cartMenu').removeClass('open static');
            $(window).off('scroll', window.linksoft.miniCartSetFixed);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Cart, [{
        key: 'componentDidMount',


        // componentWillMount = () => {
        //     this.props.discardChanges();
        // };

        value: function componentDidMount() {
            var initialState = JSON.parse(this._root.parentNode.attributes['data-component-props'].value);
            this._root.parentNode.removeAttribute('data-component-props');
            this.props.update(initialState.cart);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var cart = this.props.cart;

            if (cart.items.length > 0) {
                setTimeout(function () {
                    $("#cartMenu").find(".scrollPane").mCustomScrollbar({
                        advanced: {
                            updateOnContentResize: true
                        },
                        scrollButtons: {
                            enable: false
                        }
                    });
                }, 0);
            }

            if (cart.items.length === 0 && cart.giftItems.length === 0) {
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'emptyCart', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: (0, _urls2.default)('cart') },
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _linksoftAlbatros.formatPrice)(0, _linksoftAlbatros.PriceType.CartTotalPrice)
                        ),
                        _react2.default.createElement('i', { className: 'icon--cart' })
                    )
                );
            } else {
                var cartItemAmounts = cart.itemAmounts.length > 0 ? cart.itemAmounts.map(function (x) {
                    return x.amount;
                }).reduce(function (a, b) {
                    return a + b;
                }) : 0;
                var cartGiftItemAmounts = cart.giftItems.length > 0 ? cart.giftItems.map(function (x) {
                    return x.amount;
                }).reduce(function (a, b) {
                    return a + b;
                }) : 0;
                var maxGiftItems = cart.miniCartMaxItems - cart.items.length;
                // render entire cart
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'dropdown', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: (0, _urls2.default)('cart'), className: 'dropdown-toggle dropdown-toggle--click', 'data-toggle': 'dropdown' },
                        _react2.default.createElement(
                            'strong',
                            { className: 'mini-c__money' },
                            Resx.App.CartSummaryFormat.replace('{0}', cart.items.length + cart.giftItems.length).replace('{1}', (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice))
                        ),
                        _react2.default.createElement(
                            'i',
                            { className: 'icon--cart' },
                            _react2.default.createElement(
                                'span',
                                { className: 'mini-c__info' },
                                Resx.App.CartItemAmount.replace('{0}', cart.itemAmounts.length + cart.giftItems.length).replace('{1}', cartItemAmounts + cartGiftItemAmounts)
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown__content mini-c__wrap' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            Resx.App.ShoppingCart
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'miniCartTable scrollPane' },
                            _react2.default.createElement(
                                'div',
                                { className: 'mini-c__table' },
                                cart.items.slice(0, cart.miniCartMaxItems).map(function (item) {
                                    return _react2.default.createElement(_CartItem2.default, { key: item.id, data: item, canChangeCart: cart.canChangeCart });
                                }),
                                maxGiftItems > 0 && cart.giftItems.slice(0, maxGiftItems).map(function (item) {
                                    return _react2.default.createElement(_GiftItemMini2.default, { key: item.giftId, data: item, canChangeCart: cart.canChangeCart });
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mini-c__total' },
                            _react2.default.createElement(
                                'a',
                                { href: (0, _urls2.default)('cart'), className: 'pull-left btn btn--sm' },
                                Resx.App.ToTheOrder
                            ),
                            _react2.default.createElement(
                                'h3',
                                null,
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    Resx.App.Total,
                                    ':'
                                ),
                                ' ',
                                (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                            )
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: '#', className: 'mini-c__close', onClick: this.closeMiniCart },
                            _react2.default.createElement('i', { className: 'icon--cross' })
                        )
                    )
                );
            }
        }
    }]);
    return Cart;
}(_react.Component);

Cart.propTypes = {
    cart: _react.PropTypes.object.isRequired,

    update: _react.PropTypes.func.isRequired,
    empty: _react.PropTypes.func.isRequired
    //discardChanges: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        cart: state.cart
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    update: _actions2.default.update,
    empty: _actions2.default.empty
    //discardChanges: actions.discardChanges
})(Cart);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart.js
// module id = 1151
// module chunks = 0